module.exports = __webpack_public_path__ + "img/NichtGutKirschenEssen.652c1d23.jpg";